<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7925 8.67558L10.8138 8.65424H10.7837H3.33366C3.14792 8.65424 2.99282 8.59155 2.8675 8.46623C2.74218 8.34092 2.67949 8.18581 2.67949 8.00007C2.67949 7.81433 2.74218 7.65923 2.8675 7.53391C2.99282 7.40859 3.14792 7.34591 3.33366 7.34591H10.7837H10.8138L10.7925 7.32457L7.52583 4.0579C7.39477 3.92684 7.33238 3.77457 7.33782 3.60046C7.34327 3.42615 7.4112 3.27363 7.5423 3.14244C7.67343 3.02232 7.82607 2.95969 8.00072 2.95423C8.17482 2.94879 8.3271 3.01119 8.45815 3.14225L12.8582 7.54224C12.9237 7.60779 12.9698 7.67847 12.9969 7.75428C13.0241 7.83061 13.0378 7.91251 13.0378 8.00007C13.0378 8.08764 13.0241 8.16954 12.9969 8.24587C12.9698 8.32167 12.9237 8.39236 12.8582 8.4579L8.45815 12.8579C8.33843 12.9776 8.1889 13.0376 8.00866 13.0376C7.82849 13.0376 7.67325 12.9777 7.5423 12.8577C7.41137 12.7267 7.34616 12.5716 7.34616 12.3917C7.34616 12.2118 7.41143 12.0566 7.5425 11.9256L10.7925 8.67558Z"
      :fill="color"
      stroke="white"
      stroke-width="0.025"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '16',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
